import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { GetProductsRequestPost, Product, ProductsUtils } from '../../common';

@Component({
    selector: 'ca-product-tile',
    templateUrl: './product-tile.component.html',
    styleUrls: ['./product-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductTileComponent {
    readonly placeholderImageSrc = ProductsUtils.placeholderImageSrc;
    product = input.required<Product>();
    languageCode = input.required<GetProductsRequestPost['languageCode']>();
    countryCode = input.required<GetProductsRequestPost['countryCode']>();
    isSelected = input<boolean>(false);
    selectProduct = output<Product>();
}
